import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { RoiReadModel } from '~/domain/readmodels/StructureSetReadModel';
import useRoi from '~/hooks/structure-set/useRoi';
import { autoShownRoiNumberState } from '~/state/atoms/structureSet/roiAtoms';

/**
 * Deselects `roi`, which must be the selected structure. A structure that
 * selecting it showed only for the selection is hidden again; one the user
 * showed stays shown.
 */
export default function useRoiDeselect(roi: RoiReadModel): () => void {
    const { setVisible, setRoiSelected } = useRoi(roi);
    const [autoShown, setAutoShown] = useRecoilState(autoShownRoiNumberState);
    const wasAutoShown = autoShown === roi.roiNumber;
    return useCallback(() => {
        if (wasAutoShown) {
            setVisible(false);
        }
        setAutoShown(null);
        // Selecting the selected structure deselects it.
        setRoiSelected();
    }, [wasAutoShown, setVisible, setAutoShown, setRoiSelected]);
}
